module.exports = __webpack_public_path__ + "img/halal.d74f1377.png";